import { Fragment, useEffect, useRef, useState } from "react";
import styles from "./TransAuth.module.scss";
import OtpInput from "../../elements/Inputs/OtpInput";
import PinInput from "../../elements/Inputs/PinInput";
import { TradeAuthType } from "@/stores/dataStore/memoryStore/const/constIndex";
import { Box, CircularProgress, FormControl, MenuItem, Select, Stack, Switch, useTheme } from "@mui/material";
import Grid from '@mui/material/Grid2';
import ButtonElement from "@/views/elements/button/ButtonElement";
import { useTradeAuthenticated } from "@/controllers/gridManager/appManager/appManager";
import { doInit2factorAuth, doResendOTP } from "@/controllers/gridManager/accountsManager/accountManager";
import { useTranslation } from "react-i18next";
import TypographyElement from "@/views/elements/typography/TypographyElement";
import { debounce } from "lodash";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const TIME_COUNTDOWN = 60

let intervalOTP: any = null

const TransAuthInput = (
    (
        {
            autoFocus,
            disabledSaveAuth = false,
            hiddenAuth = false,
            disabledAuth = false,
            onChange = () => { }
        }: any
    ) => {
        const { t } = useTranslation()
        const theme = useTheme()
        const countRef = useRef<number>(TIME_COUNTDOWN)
        const [count, setCount] = useState<number>()
        const [showPin, setShowPin] = useState(false);
        const toggleShowPin = () => setShowPin((prev) => !prev);
        const [disabledSend, setDisabledSend] = useState<boolean>(false)

        const [listAuthType, setListAuthType] = useState([]);
        const [verified, setVerified] = useState(false);
        const [auth, setAuth] = useState({
            tokenid: '',
            transactionId: '',
            authtypes: [],
            authtype: '',
            authtypeVerified: null,
            challengeQuestion: null,
            codeNoti: null,
            tokenInfo: null,
            verified: false
        });
        const [input, setInput] = useState({
            tokenid: '',
            transactionId: '',
            authtype: '',
            code: '',
            isSaveVerify: false
        });

        useEffect(() => {
            if (disabledSend === true) {
                countRef.current = TIME_COUNTDOWN
                setCount(TIME_COUNTDOWN)

                intervalOTP = setInterval(() => {
                    if (countRef.current === 0) {
                        setDisabledSend(false)
                        intervalOTP && clearInterval(intervalOTP)
                    }
                    countRef.current = countRef.current - 1 >= 0 ? countRef.current - 1 : 0
                    setCount(countRef.current)
                }, 1000);
            }

            return () => {
                intervalOTP && clearInterval(intervalOTP)
            }
        }, [disabledSend])



        const mapAuthType = (itemType: string) => {
            const arrayAuthType = Object.values(TradeAuthType)
            const indexResult = arrayAuthType.findIndex(item => item === itemType)
            return Object.keys(TradeAuthType)[indexResult]
        }

        const debounceSendOTP = debounce(() => genAuthCode(), 300)

        const handleInputChange = (data: any) => {
            setInput(input => ({ ...input, ...data }))
            onChange({ ...input, ...data })
        }

        const genAuthCode = async () => {
            let { isSuccess, data } = await doResendOTP({ transactionId: auth.transactionId, authtype: auth.authtype })
            if (isSuccess) {
                setDisabledSend(true)
                setAuth(data)
                handleInputChange({
                    tokenid: data.tokenid,
                    transactionId: data.transactionId
                })
            }
        }

        const initAuth = async () => {
            let { isSuccess, data } = await doInit2factorAuth()
            if (isSuccess) {
                setAuth(data)
                handleInputChange({
                    tokenid: data.tokenid,
                    transactionId: data.transactionId,
                    authtype: data.authtype,
                    isSaveVerify: data.verified
                })
                setVerified(data.verified)
                setListAuthType(data.authtypes)
            }
        }

        useEffect(() => {
            initAuth()
        }, [])

        const { authtype, code } = input

        return (
            listAuthType.length === 0 ? <Stack width='460px' height='150px' justifyContent='center' alignItems='center'>
                <CircularProgress color="primary" />
            </Stack> :
                <Fragment>
                    <div className={styles.transAuth2Container}>
                        {!verified && <Stack
                            spacing={2}
                            direction={"column"}
                        >
                            <Box>
                                <Grid container spacing={2} columns={24}>
                                    <Grid size={8}>
                                        <Box
                                        >
                                            {t('copytrade.transAuth.authMethod')}
                                        </Box>
                                    </Grid>
                                    <Grid size={16}>
                                        <Box
                                        >
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="authtype-select-label"
                                                    id="authtype-select"
                                                    value={authtype}
                                                    size='small'
                                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, background: theme.palette.background.input }}
                                                    onChange={(e) => handleInputChange({ authType: e.target.value })}
                                                >
                                                    {
                                                        listAuthType.map((itemType: any, index: number) => {
                                                            return <MenuItem value={itemType}>{mapAuthType(itemType)}</MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                            {authtype === TradeAuthType.PIN && (
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2} columns={24}>
                                        <Grid size={8}>
                                            <Box className={`${styles.defaultLabel}`}>
                                                <span className={styles.label}>
                                                    {t('copytrade.transAuth.password')}
                                                </span>
                                            </Box>
                                        </Grid>
                                        <Grid size={16}>
                                            <Box className={`${styles.defaultInputField}`}>
                                                <PinInput
                                                    autoFocus={autoFocus}
                                                    onChange={(value: any) => handleInputChange({ code: value })}
                                                    toggleShowPin={toggleShowPin}
                                                    showPin={showPin}
                                                    value={!hiddenAuth ? code : "•••••••"}
                                                    disabled={disabledAuth}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>

                            )}

                            {authtype === TradeAuthType.OTP && (
                                <Grid container spacing={2} columns={24} className={styles.otpContainer}>
                                    <Grid size={8} className={`${styles.defaultLabel}`}>
                                        <span className={styles.label}>
                                            {t('copytrade.transAuth.smsOtp')}
                                        </span>
                                    </Grid>
                                    <Grid size={16} className={`${styles.defaultInputField}`}>
                                        <OtpInput
                                            autoFocus={autoFocus}
                                            value={!hiddenAuth ? code : "•••••••"}
                                            disabled={disabledAuth}
                                            onChange={(value: any) => handleInputChange({ code: value })}
                                            hiddenPaddingRight={true}
                                            endAdornment={
                                                disabledSend ? <ButtonElement sx={{
                                                }} disabled={true} onClick={debounceSendOTP} customType="Transparent">
                                                    <TypographyElement sx={{
                                                        whiteSpace: "nowrap",
                                                    }} ColorElement="brand">{count}</TypographyElement>
                                                </ButtonElement> : <ButtonElement onClick={debounceSendOTP} customType="Transparent">
                                                    <TypographyElement sx={{
                                                        textDecoration: "underline",
                                                        whiteSpace: "nowrap",
                                                    }} ColorElement="brand">Lấy SMS-OTP</TypographyElement>
                                                </ButtonElement>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {authtype === TradeAuthType.SMARTOTP && (
                                <Grid container spacing={2} columns={24} className={styles.smartOtpContainer}>
                                    <Grid size={8}
                                        className={`${styles.defaultLabel}`}
                                    >
                                        <span className={styles.label}>
                                            {t('copytrade.transAuth.smartOtp')}
                                        </span>
                                    </Grid>
                                    <Grid size={16} className={`${styles.defaultInputField}`}>
                                        <OtpInput
                                            autoFocus={autoFocus}
                                            value={!hiddenAuth ? code : "•••••••"}
                                            onChange={(value: any) => handleInputChange({ code: value })}
                                            disabled={disabledAuth}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {authtype === TradeAuthType.CTS && <>CTS</>}

                            {authtype === TradeAuthType.TOKEN && <>TOKEN</>}

                            {authtype === TradeAuthType.MATRIX && <>MATRIX</>}

                            {!disabledSaveAuth && (
                                <Grid container spacing={2} columns={24} className={`${styles.saveAuthenticationContainer}`}>
                                    <Grid size={8}>
                                        <span className={styles.label}>
                                            {t("copytrade.common.saveVerify")}
                                        </span>
                                    </Grid>
                                    <Grid size={12}>
                                        <span className={styles.toggleSaveAuth}>
                                            <Switch
                                                checked={input.isSaveVerify}
                                                defaultChecked={verified}
                                                onChange={(e) => handleInputChange({ isSaveVerify: e.target.checked })}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </span>
                                    </Grid>
                                </Grid>
                            )}
                        </Stack>}

                        {verified && <Stack
                            spacing={1}
                            direction={"row"}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <CheckCircleOutlineIcon sx={{ fontSize: "30px" }} color="success" />
                            <TypographyElement ColorElement="brand" >
                                {t('copytrade.common.verified')}
                            </TypographyElement>
                        </Stack>}
                    </div>
                </Fragment>
        );
    }
);

export default TransAuthInput;